/**
 * Contact block.
 *
 * Converted verbatim from `public/index.html:509-525`.
 */

const ContactSection = () => (
  <section id="contact" className="contact-section">
    <div className="section-header">
      <h2 className="section-title">Get in Touch</h2>
      <p className="section-subtitle">Have questions? We're here to help</p>
    </div>
    <div className="contact-content">
      <a
        href="mailto:pankaj.rajdeo@cchmc.org,nathan.salomonis@cchmc.org,michal.kouril@cchmc.org"
        className="contact-card"
        style={{ textDecoration: 'none', display: 'block' }}
      >
        <svg
          className="contact-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
        <h3>Contact Us</h3>
        <p>Send us an email</p>
      </a>
    </div>
  </section>
);

export default ContactSection;
